<template>
  <div id="manager-managers">
    <div class="table-add">
      <el-button
        @click="openManagerDialog('setting', -1)"
        size="medium"
        type="primary"
        >新增管理员</el-button
      >
    </div>
    <div class="table-container">
      <el-table :data="managersList" stripe style="width: 100%">
        <el-table-column prop="user_name" label="工号"> </el-table-column>
        <el-table-column prop="real_name" label="姓名"> </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <el-tag
              size="small"
              :type="scope.row.status == 1 ? 'success' : 'info'"
              >{{ MANAGER_STATUS[scope.row.status] }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column label="操作" width="280">
          <template slot-scope="scope">
            <el-button
              size="small"
              @click="openManagerDialog('setting', scope.row.id, scope.row)"
              v-if="scope.row.role != 'boss'"
              type="primary"
              >权限管理</el-button
            >
            <el-button
              size="small"
              @click="openManagerDialog('company', scope.row.id)"
              v-if="scope.row.role != 'boss'"
              type="primary"
              >公司管理</el-button
            >
            <el-button
              size="small"
              v-if="scope.row.status != 0 && scope.row.role != 'boss'"
              @click="deleteManager(scope.row, scope.$index)"
              type="danger"
              >禁用</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="table-page">
        <el-pagination
          small
          layout="prev, pager, next"
          :total="total_count"
          :current-page="page"
          @current-change="getManagersList"
        >
        </el-pagination>
      </div>
    </div>
    <managerSetting
      :managersDialogType.sync="managersDialogType"
      :managerId="showManagerId"
      :managerInfo="showManagerInfo"
      @updateManagersList="getManagersList(page)"
    />
    <managerCompany
      :managersDialogType.sync="managersDialogType"
      :managerId="showManagerId"
    />
  </div>
</template>

<script>
import { managerManagersList, managerDeleteManager } from '@/api/manager'
import managerSetting from './components/manager_setting'
import managerCompany from './components/company'
export default {
  name: 'manager-managers',
  components: {
    managerSetting,
    managerCompany,
  },
  data() {
    return {
      total_count: 0,
      page: 1,
      managersList: [],
      managersDialogType: '',
      showManagerId: '',
      showManagerInfo: {},
    }
  },
  mounted() {
    this.getManagersList()
  },
  methods: {
    async getManagersList(_page = 1) {
      this.page = _page
      let { code, result } = await managerManagersList({
        page: this.page,
        pageSize: 10,
      })
      if (code == this.CONFIG.CODE_SUCCESS) {
        this.managersList = result.list
        this.total_count = result.total_count
      }
    },
    openManagerDialog(_type, _id, _item) {
      this.showManagerId = _id
      this.showManagerInfo = _item
      this.managersDialogType = _type
    },
    async deleteManager(_row, _index) {
      this.$confirm(
        '此操作将禁用该账号"' + _row.user_name + '", 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      )
        .then(async () => {
          let { code, msg } = await managerDeleteManager({
            manager_id: _row.id,
          })
          if (code == this.CONFIG.CODE_SUCCESS) {
            this.managersList[_index].status = 0
            this.$message({
              type: 'success',
              message: msg,
            })
          }
        })
        .catch(() => {})
    },
  },
}
</script>

<style lang="less" scoped>
.table-container {
  width: 100%;
}
.table-add {
  margin: 7px 0 15px 0;
}
.table-container {
  padding: 8px;
  background: #fff;
  border-radius: 5px;
}
.table-page {
  margin-top: 15px;
  text-align: center;
}
</style>
